import type {IStateStorage} from "./state";

export function isIpcMessage(obj: unknown): obj is IpcMessage {
    return !!obj && typeof obj === 'object' && 'type' in obj;
}

export type IpcMessageRequestValidation = {
    type: 'request-validation';
    id: string;
}
export type IpcMessageRequestDump = {
    type: 'request-dump';
    id: string;
}
export type IpcMessageStateDump = {
    type: 'state-dump';
    id: string;
    state: IStateStorage;
}
export type IpcMessageAcknowledgement = {
    type: 'ack';
    id: string;
}
export type IpcMessageChecksum = {
    type: 'checksum';
    id: string;
    checksum: Uint32Array
}
export type IpcMessageVersion = {
    type: 'version';
    version: number;
}
export type IpcMessage =
    IpcMessageRequestValidation
    | IpcMessageRequestDump
    | IpcMessageStateDump
    | IpcMessageAcknowledgement
    | IpcMessageChecksum
    | IpcMessageVersion;
export type ResendableIpcMessage = Exclude<IpcMessage, IpcMessageVersion>;

export function isResendableMessage(message: IpcMessage): message is ResendableIpcMessage {
    return 'id' in message && typeof message.id === 'string' && message.id.length > 0;
}
